module.exports = __webpack_public_path__ + "img/content-1.5aebdf7c.png";